import React, { Suspense } from 'react';

import { Switch, Router, Route } from 'react-router';

import { makeRoutes, routesTypes } from '@app/routes';

import { LayoutProvider } from '@features/LayoutProvider';

import { PageLoader } from '@ui/atoms/PageLoader';

import { history } from '@libs/history/model';

const renderRoutes = (routes: routesTypes.Route[]) => (
  <Router history={history}>
    <Switch>
      <LayoutProvider>
        {routes.map((route, index) => {
          const RouteComponent = route.component;
          if (!route.path) {
            <RouteComponent key={index} />
          }
          return (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              render={props => (
                <>
                  <Suspense fallback={<div className="mt-5"><PageLoader /></div>}>
                    <RouteComponent {...props}>
                    {route.resources &&
                      <Switch>
                        {route.resources?.map((resource, idx) => (
                          <Route
                            key={idx}
                            path={resource.path}
                            exact={resource.exact}
                            render={props => (
                              <Suspense fallback={<div className="mt-5"><PageLoader /></div>}>
                                <resource.component {...props} />
                              </Suspense>
                            )}
                          />
                        ))}
                      </Switch>}
                    </RouteComponent>
                  </Suspense>
                </>
              )}
            />
          );
        })}
      </LayoutProvider>
    </Switch>
  </Router>
);

export const Pages: React.FC = () => {
  return renderRoutes(makeRoutes());
};